export const FIND_CHAT_CONVERSATION_PARTNERS_SUCCESS = 'FIND_CHAT_CONVERSATION_PARTNERS_SUCCESS';

export const findChatConversationPartnersSuccess = ({ conversationPartners }) => ({
    type: FIND_CHAT_CONVERSATION_PARTNERS_SUCCESS,
    payload: { conversationPartners },
});
